package com.deange.nastychristmas.firebase

class Firebase(
  val firestore: Firestore,
)
